import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "../components/Typography";

export default function ProductCategories() {
  return (
    <Container component="section" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" marked="center" align="center" component="h2">
        A developer for all seasons
      </Typography>
      <Box sx={{ mt: 8, display: "flex", flexDirection: "column", gap: "3em" }}>
        <img
          src="/images/headshot.jpg"
          alt="Dan headshot"
          loading="lazy"
          style={{
            maxWidth: "533px",
            maxHeight: "400px",
            width: "100%",
            height: "auto",
            margin: "0 auto",
          }}
        />
        <Typography variant="h5" paragraph>
          Hello, I'm Dan, a seasoned developer with 16 years of experience under
          my belt.
        </Typography>
        <Typography variant="h5" paragraph>
          Over the years, I've honed my craft with traditional development
          models and also gained expertise in the latest cloud technologies. I'm
          a certified Salesforce developer, app builder, and architect, ready to
          help you tackle your business challenges. Whether it's a custom
          solution or an integration, I'll work with you to create a bespoke
          plan that fits your unique needs and budget.
        </Typography>
      </Box>
    </Container>
  );
}
